
const TOKEN_KEY = "token";
const IS_LOGIN_KEY = "isLogin";
const TOKEN_EXPIRES_AT_KEY = "token_expires_at";

// 与后端 token 有效期保持一致：1 年
const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

function getExpiresAt() {
  return Date.now() + ONE_YEAR_MS;
}

function removeAuthFromStorage(storage) {
  storage.removeItem(TOKEN_KEY);
  storage.removeItem(IS_LOGIN_KEY);
  storage.removeItem(TOKEN_EXPIRES_AT_KEY);
}

function isTokenExpiredInStorage(storage) {
  const token = storage.getItem(TOKEN_KEY);
  if (!token) return false;

  const expiresAtRaw = storage.getItem(TOKEN_EXPIRES_AT_KEY);
  // 兼容历史数据：没有 expiresAt 的 token，认为未过期（交由后端 401 再兜底）
  if (!expiresAtRaw) return false;

  const expiresAt = Number(expiresAtRaw);
  if (!Number.isFinite(expiresAt)) return false;

  return Date.now() >= expiresAt;
}

/**
 * 设置 token（浏览器缓存适配：写入 1 年的过期时间）
 * @param {string} token 需要存储的 token（当前项目约定通常为 "Bearer xxx"）
 * @param {boolean} isRememberMe true -> localStorage；false -> sessionStorage
 */
export function setToken(token, isRememberMe) {
  const storage = isRememberMe ? localStorage : sessionStorage;
  const otherStorage = isRememberMe ? sessionStorage : localStorage;

  // 写入目标 storage
  storage.setItem(TOKEN_KEY, token);
  storage.setItem(IS_LOGIN_KEY, "true");
  storage.setItem(TOKEN_EXPIRES_AT_KEY, String(getExpiresAt()));

  // 清理另一个 storage，避免出现“双份 token”导致读取混乱
  removeAuthFromStorage(otherStorage);
}

export function clearAuth() {
  removeAuthFromStorage(localStorage);
  removeAuthFromStorage(sessionStorage);
}

export function clearUserInfoCache() {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("username");
  sessionStorage.removeItem("userInfo");
  sessionStorage.removeItem("username");
}

export function isLoggedIn() {
  return (
    localStorage.getItem(IS_LOGIN_KEY) === "true" ||
    sessionStorage.getItem(IS_LOGIN_KEY) === "true"
  );
}

/**
 * 退出登录时清理业务缓存，但保留用户主动勾选“记住我”保存的登录信息。
 */
export function clearStoragePreservingRememberedLogin() {
  const rememberedLogin = localStorage.getItem("loginForm");

  localStorage.clear();
  sessionStorage.clear();

  if (rememberedLogin) {
    localStorage.setItem("loginForm", rememberedLogin);
  }
}

/**
 * 获取 token（会在读取时做 1 年过期判断；过期则自动清理）
 */
export function getToken() {
  if (isTokenExpiredInStorage(localStorage)) {
    removeAuthFromStorage(localStorage);
  }
  if (isTokenExpiredInStorage(sessionStorage)) {
    removeAuthFromStorage(sessionStorage);
  }

  return (
    localStorage.getItem(TOKEN_KEY) ||
    sessionStorage.getItem(TOKEN_KEY) ||
    getURLParameters(location.href).token
  );
}

/**
 * 应用启动时调用，用于修复历史缓存数据（避免 isLogin=true 但 token 丢失等问题）
 */
export function normalizeAuthCache() {
  // 1) token 存在但未写 expiresAt：补写 1 年（与当前后端保持一致）
  const localToken = localStorage.getItem(TOKEN_KEY);
  if (localToken && !localStorage.getItem(TOKEN_EXPIRES_AT_KEY)) {
    localStorage.setItem(TOKEN_EXPIRES_AT_KEY, String(getExpiresAt()));
  }
  const sessionToken = sessionStorage.getItem(TOKEN_KEY);
  if (sessionToken && !sessionStorage.getItem(TOKEN_EXPIRES_AT_KEY)) {
    sessionStorage.setItem(TOKEN_EXPIRES_AT_KEY, String(getExpiresAt()));
  }

  // 2) 过期则清理
  if (isTokenExpiredInStorage(localStorage)) {
    removeAuthFromStorage(localStorage);
  }
  if (isTokenExpiredInStorage(sessionStorage)) {
    removeAuthFromStorage(sessionStorage);
  }

  // 3) isLogin=true 但 token 不存在：清掉 isLogin（避免前端误判已登录）
  const localIsLogin = localStorage.getItem(IS_LOGIN_KEY);
  if (localIsLogin === "true" && !localStorage.getItem(TOKEN_KEY)) {
    localStorage.removeItem(IS_LOGIN_KEY);
    localStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
  }
  const sessionIsLogin = sessionStorage.getItem(IS_LOGIN_KEY);
  if (sessionIsLogin === "true" && !sessionStorage.getItem(TOKEN_KEY)) {
    sessionStorage.removeItem(IS_LOGIN_KEY);
    sessionStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
  }
}

export function setUserInfo(userInfo) {

}
export function getUserInfo() {

}


export function getURLParameters(url=location.href) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url.replace('#/','');
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  }
